import script from "./payment.vue?vue&type=script&setup=true&lang=js"
export * from "./payment.vue?vue&type=script&setup=true&lang=js"

import "./payment.vue?vue&type=style&index=0&id=732a9bb6&lang=css"

const __exports__ = script;

export default __exports__